/**
 * This is the securityquestion routes configuration.
 * Only configure routes in this file.
 * @memberOf securityquestion Module
 * @namespace securityquestion Routes
 */
import verifyTemplate from './rsa.verify.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf securityquestion Module.verify Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the securityquestion verify state and assign the template and controller. */
    $stateProvider
		.state('login.securityquestion.rsa.verify', {
			url: '/verify',
			template: verifyTemplate,
			controller: 'rsaVerifyController',
			controllerAs: 'vm'
		});
};

export default config;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/verify/rsa.verify.route.js